import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    maxWidth: "80px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
    maxWidth: "80px"
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function EmailOtherAccountsTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: '8px' }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Email</TableCell>
            <TableCell className={classes.tableHeader}>Razão Social</TableCell>
            <TableCell className={classes.tableHeader}>N° do Documento da Conta</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.email_other_accounts_data.map((item, index) =>
            item.other_accounts.map((other_account, subIndex) => (
              <TableRow key={`${index}-${subIndex}`} className={getClass(subIndex)}>
                <TableCell style={{ whiteSpace: "nowrap" }} className={classes.tableText}>
                  {item.email}
                </TableCell>
                <TableCell className={classes.tableText}>
                  {other_account.name}
                </TableCell>
                <TableCell className={classes.tableText}>
                  {other_account.document_number}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default EmailOtherAccountsTable;
